<template>
  <div class="ui modal" ref="modal">
    <div class="ui inverted dimmer">
      <div class="ui text double slow blue loader">{{ $t("loading") }}</div>
    </div>
    <i class="close icon"></i>
    <div class="icon header">
      <i class="filter icon"></i>
      {{ $t("course preinscription filter") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img src="/images/icons/students.png" style="width: 100% !important" />
      </div>
      <div class="description" style="width: 100% !important">
        <preinscription-filter
          :section="section"
          :careers="careers"
          :branches="branches"
          :studying_times="studying_times"
          :season="season"
          @add_item="student_added"
          :course="section.crs_course.course_id"
          @add_selected="add_selected"
          :users="users"
          ref="preinscription_filter"
        />
      </div>
    </div>
    <div class="actions">
      <div class="ui blue icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
    </div>
  </div>
</template>

<script>
import PreinscriptionFilter from "./PreinscriptionFilter.vue";

export default {
  name: "PreinscriptionFilterModal",
  components: { PreinscriptionFilter },
  props: {
    careers: Array,
    branches: Array,
    studying_times: Array,
    section: Object,
    season: Object,
    course: String,
    users: Array,
  },
  data() {
    return {};
  },
  methods: {
    show_modal(/* data */) {
      let vm = this;
      window
        .jQuery(vm.$refs.modal)
        .modal({
          onHidden() {
            vm.$refs.preinscription_filter.clear();
          },
        })
        .modal("show");
    },
    student_added(item) {
      this.$emit("add_item", item);
    },
    add_selected(students) {
      let vm = this;
      vm.$emit("add_selected", students);
      window.jQuery(vm.$refs.modal).modal("hide");
    },
  },
  mounted() {},
};
</script>
